import { error99, Marca, RetAPI } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const MarcaService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('Marca/attributes', 'get', { id })
        const attributes: Marca = {
            id: 0,
            description: '',
            id_user_insert: 0,
            id_user_last_update: 0,
            id_user_exclusao: 0,
            motivo_exclusao: '',
            dt_cadastro: '',
            dt_last_update: '',
            dh_exclusao: '',
            name_user_insert: '',
            name_user_last_update: '',
            name_user_delete: ''
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.marca) {

                    attributes.id = resp.data.marca.id
                    attributes.description = resp.data.marca.descricao
                    attributes.id_user_insert = resp.data.marca.id_user_insert
                    attributes.id_user_last_update = resp.data.marca.id_user_last_update
                    attributes.id_user_exclusao = resp.data.marca.id_user_exclusao
                    attributes.motivo_exclusao = resp.data.marca.motivo_exclusao
                    attributes.dt_cadastro = resp.data.marca.dt_cadastro
                    attributes.dt_last_update = resp.data.marca.dt_last_update
                    attributes.dh_exclusao = resp.data.marca.dh_exclusao
                    attributes.name_user_insert = resp.data.marca.name_user_insert
                    attributes.name_user_last_update = resp.data.marca.name_user_last_update
                    attributes.name_user_delete = resp.data.marca.name_user_delete

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (marca: Marca): Promise<RetAPI> => {

        let id = ''

        if (marca.id) {
            id = marca.id.toString()
        }

        const resp = await Api('Marca/save', 'post', {
            descricao: marca.description, id
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados da marca gravados com sucesso',
                id: resp.data.marca.id,
                data: resp.data,
                dt_cadastro: resp.data.marca.dt_cadastro,
                dt_last_update: resp.data.marca.dt_last_update,
                name_user_insert: resp.data.marca.name_user_insert,
                name_user_last_update: resp.data.marca.name_user_last_update
            }
            
        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Marca/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('Marca/filter', 'get', { field, filter_type, filter, id })
        const marcas: Marca[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: marcas
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.marcas.map((item: any) => {
                    return marcas.push({

                        id: item.id,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        description: item.descricao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete

                    })
                })
            } 

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: marcas
            }
        }

        return {
            error: false,
            data: marcas
        }
    },

    Relatorio: async (datai: string, dataf: string, descricao?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('Marca/Report/relatorio', 'get', { datai, dataf, descricao, mostrar_excluidas })
        const marcas: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: marcas
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.marcas.map((item: any) => {
                    return marcas.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        descricao: item.descricao

                    })
                })
            } 

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: marcas
            }
        }

        return {
            error: false,
            data: marcas,
        }
        
    }
}
